var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('form', {
    attrs: {
      "id": "outcome-submit"
    },
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.saveDebt.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "form-2"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "cis-zmluy"
    }
  }, [_vm._v("Č. zmluvy")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.form.cislo_uveru,
      expression: "form.cislo_uveru",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "text-input w-input",
    attrs: {
      "type": "text",
      "maxlength": "256",
      "name": "cis-zmulvy",
      "data-name": "cis-zmluvy",
      "placeholder": "",
      "id": "cis-zmluy"
    },
    domProps: {
      "value": _vm.form.cislo_uveru
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "cislo_uveru", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _c('div', {
    staticClass: "dropdown-input-custom rest-input"
  }, [_c('dropdown-select', {
    attrs: {
      "id": 'mortgage_banka',
      "init-value": _vm.form.banka,
      "options": _vm.bankChoices,
      "normal": "",
      "name": 'Spoločnosť'
    },
    on: {
      "select": function select($event) {
        return _vm.setDropdownValue($event, 'banka');
      }
    }
  })], 1), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "Spl-tka"
    }
  }, [_vm._v("Splátka (automaticky sa stresuje)")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.form.vyska_splatky,
      expression: "form.vyska_splatky",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "text-input w-input required",
    attrs: {
      "type": "number",
      "step": "0.01",
      "maxlength": "256",
      "name": "Splatka",
      "data-name": "Splátka",
      "placeholder": "",
      "id": "Spl-tka",
      "required": ""
    },
    domProps: {
      "value": _vm.form.vyska_splatky
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "vyska_splatky", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "den-splatky"
    }
  }, [_vm._v("Den splátky")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.form.den_splatky,
      expression: "form.den_splatky",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "text-input w-input",
    attrs: {
      "type": "number",
      "maxlength": "256",
      "min": "1",
      "max": "32",
      "name": "den-splatky",
      "data-name": "den-splatky",
      "placeholder": "",
      "id": "den-splatky"
    },
    domProps: {
      "value": _vm.form.den_splatky
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "den_splatky", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "Zostatok"
    }
  }, [_vm._v("Zostatok")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.form.zostatok,
      expression: "form.zostatok",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "text-input w-input required",
    attrs: {
      "type": "number",
      "maxlength": "256",
      "name": "Zostatok",
      "data-name": "Zostatok",
      "placeholder": "",
      "id": "Zostatok",
      "required": ""
    },
    domProps: {
      "value": _vm.form.zostatok
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "zostatok", _vm._n($event.target.value));
      }, function ($event) {
        _vm.form.zostatok = Math.round(_vm.form.zostatok);
      }],
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "Fix-cia"
    }
  }, [_vm._v("Fixácia")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.fixacia,
      expression: "form.fixacia"
    }],
    staticClass: "text-input w-input",
    attrs: {
      "type": "text",
      "maxlength": "256",
      "name": "Fixacia",
      "min": "0",
      "data-name": "Fixacia",
      "id": "Fix-cia"
    },
    domProps: {
      "value": _vm.form.fixacia
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "fixacia", $event.target.value);
      }
    }
  })]), _vm._m(0), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.additionalBalance.suma,
      expression: "additionalBalance.suma",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "text-input w-input",
    attrs: {
      "type": "number",
      "step": "0.01",
      "maxlength": "256",
      "name": "pocietoc-obj",
      "data-name": "pocietoc-obj",
      "placeholder": "",
      "id": "pocietoc-obj"
    },
    domProps: {
      "value": _vm.additionalBalance.suma
    },
    on: {
      "change": _vm.calculateRest,
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.additionalBalance, "suma", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.additionalBalance.sadzba,
      expression: "additionalBalance.sadzba",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "text-input w-input",
    attrs: {
      "type": "number",
      "maxlength": "256",
      "name": "Sadzba",
      "step": "0.01",
      "data-name": "Sadzba",
      "placeholder": "",
      "id": "Sadzba"
    },
    domProps: {
      "value": _vm.additionalBalance.sadzba
    },
    on: {
      "change": _vm.calculateRest,
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.additionalBalance, "sadzba", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), !_vm.$v.additionalBalance.sadzba.maxDigits ? _c('span', {
    staticClass: "clientError"
  }, [_vm._v(" Maximálny počet cifier je " + _vm._s(_vm.$v.additionalBalance.sadzba.$params.maxDigits["upperLimit"]) + " ")]) : _vm._e(), !_vm.$v.additionalBalance.sadzba.maxInteger ? _c('span', {
    staticClass: "clientError"
  }, [_vm._v(" Maximálny počet cifier pred bodkou je " + _vm._s(_vm.$v.additionalBalance.sadzba.$params.maxInteger["maxInteger"]) + " ")]) : _vm._e(), !_vm.$v.additionalBalance.sadzba.maxDecimal ? _c('span', {
    staticClass: "clientError"
  }, [_vm._v(" Maximálny počet cifier za bodkou je " + _vm._s(_vm.$v.additionalBalance.sadzba.$params.maxDecimal["maxDecimal"]) + " ")]) : _vm._e(), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "zaciatok-hypoteka"
    }
  }, [_vm._v("Začiatok splácania")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.additionalBalance.zaciatok,
      expression: "additionalBalance.zaciatok"
    }],
    staticClass: "text-input w-input date-input",
    attrs: {
      "type": "date",
      "max": _vm.todayLong,
      "maxlength": "256",
      "name": "zaciatok-hypoteka",
      "data-name": "zaciatok-hypoteka",
      "id": "zaciatok-hypoteka"
    },
    domProps: {
      "value": _vm.additionalBalance.zaciatok
    },
    on: {
      "change": _vm.calculateRest,
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.additionalBalance, "zaciatok", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "splatnost-hypoteka"
    }
  }, [_vm._v("Splatnosť hypotéky v "), _c('span', {
    staticClass: "bl-color",
    on: {
      "click": _vm.changeMaturityMode
    }
  }, [_vm._v(_vm._s(_vm.maturityYears ? "rokoch" : "mesiacoch"))])]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.additionalBalance.maturity,
      expression: "additionalBalance.maturity",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "text-input w-input",
    attrs: {
      "type": "number",
      "min": "0",
      "step": ".01",
      "maxlength": "256",
      "name": "splatnost-hypoteka",
      "data-name": "splatnost-hypoteka",
      "id": "splatnost-hypoteka"
    },
    domProps: {
      "value": _vm.additionalBalance.maturity
    },
    on: {
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")) return null;
        $event.preventDefault();
      },
      "change": _vm.calculateRest,
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.additionalBalance, "maturity", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })])])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "splitter noselect"
  }, [_vm._v(" ak zostatok neviete, po zadaní parametrov úveru "), _c('br'), _vm._v(" nižšie ho pre Vás spočítame ")]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "pocietoc-obj"
    }
  }, [_vm._v("Počiatočný objem"), _c('strong')]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "Sadzba"
    }
  }, [_vm._v("Sadzba v %"), _c('strong')]);

}]

export { render, staticRenderFns }